import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-selected-course-card',
  templateUrl: './selected-course-card.component.html',
  styleUrls: ['./selected-course-card.component.scss']
})
export class SelectedCourseCardComponent {
  @Input() assessment: any;
}
